import { ListView } from '@app/core/list-view/ListView';
import { ListViewQueryParams } from '@app/core/list-view/types';
import { ScheduledAodRunDto } from '@app/modules/audit/modules/aod/aod.types';
import { auditReportsGetAodScheduledRunsScheduledRuns } from '@mi-front/api-v2';
import { Paginated } from '@mi-front/core';
import { AodRunsScheduledList } from './AodRunsScheduledList';

/**
 * Main page for AOD Runs Scheduled V2.
 * Fetches /aod-runs/scheduled (plain array), then applies client-side filter, sort, and pagination
 * to satisfy the ListView Paginated contract.
 */
export function AodRunsScheduledPage_v2() {
  const queryFn = async (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    params: ListViewQueryParams,
  ): Promise<Paginated<ScheduledAodRunDto>> => {
    const data = await auditReportsGetAodScheduledRunsScheduledRuns();

    return {
      results: data,
      metadata: {
        pageIndex: 0, // Convert from 1-based to 0-based indexing
        pagesCount: 1,
        showCount: 50,
        totalCount: data.length,
      },
    };
  };

  return (
    <ListView
      listId="aod-runs-scheduled-v2"
      // filters={AOD_RUNS_SCHEDULED_FILTERS_CONFIG}
      filters={[]}
      queryFn={queryFn}
      ListComponent={AodRunsScheduledList}
      actions={[]}
      defaultPageSize={20}
    />
  );
}
